import { createUseStyles } from '../../theme/theming';

const useTestimonialStyles = createUseStyles((theme) => ({
  testimonialContainer: {
    overflow: 'hidden',
    padding: `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    },
    '& h3,& p': {
      marginTop: '0'
    }
  },
  sectionContainer: {
    margin: '0 auto',
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },
  testimonialText: {
    color: theme?.colors?.lightblack,
    fontSize: theme.typography.fontSize.subHead,
    wordBreak: 'break-word',
    textTransform: 'uppercase'
  },

  testimonialHeader: {
    fontSize: theme.typography.fontSize.h2,
    color: theme?.colors?.lightblack,
    fontWeight: theme.typography.fontWeight.bold,
    marginBottom: theme.spacing.margin.tiny,
    marginTop: '8px',
    overflow: 'hidden',
    wordBreak: 'break-word',
    // whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },

  sliderContainer: {
    marginRight: `-${theme.spacing.margin.regular}px`
  },

  singleCard: {
    // margin: '6px 12px',
    position: 'relative',
    height: 'calc(100% - 12px)',
    width: 'calc(100% - 24px)',
    background: theme?.colors?.background1,
    boxShadow: theme?.shadows?.primary,
    borderRadius: theme?.shape?.borderRadius?.regular
  },
  contentRow: {
    display: 'grid',
    gridTemplateColumns: ({ slidesToShow } = {}) =>
      `repeat(${slidesToShow},minmax(0, 1fr))`
  },
  cardDetails: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '48px',
    alignItems: 'flex-start'
  },

  quoteIcon: {
    position: 'absolute',
    right: '20px'
  },
  reviewText: {
    // padding: '48px 41px 0 48px',
    marginBottom: theme.spacing.margin.tiny,
    fontSize: theme.typography.fontSize.body,
    wordBreak: 'break-word',
    color: theme?.colors?.font1,
    lineHeight: '26px'
  },
  userContainer: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center'
  },

  userImageContainer: {
    width: '64px',
    height: '64px',
    position: 'relative',
    // paddingBottom: '55px',
    objectFit: 'cover'
  },
  userImageDummy: {
    width: '64px',
    height: '64px',
    borderRadius: '32px',
    background: '#666666',
    flexShrink: '0'
  },
  userImage: {
    width: '64px',
    height: '64px',
    borderRadius: '32px',
    marginRight: '16px'
  },
  userName: {
    color: theme?.colors?.font1,
    margin: '0',
    fontSize: theme.typography.fontSize.h5,
    // paddingTop: '16px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  buttonContainer: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    // paddingRight: theme.spacing.padding.medium,
    marginTop: theme.spacing.margin.tiny
  },

  '@media (max-width: 768px)': {
    testimonialContainer: {
      padding: `${theme.spacing.padding.medium}px ${theme.spacing.padding.small}px`
    },
    testimonialText: {
      textAlign: 'center'
    },

    testimonialHeader: {
      textAlign: 'center'
    },
    userImageDummy: {
      width: '48px',
      height: '48px',
      borderRadius: '24px',
      marginRight: '16px'
    },
    userImage: {
      width: '48px',
      height: '48px',
      borderRadius: '24px',
      marginRight: '16px'
    },
    reviewText: {
      lineHeight: '22px',
      marginBottom: '16px'
    },
    singleCard: {
      margin: '6px 2px',
      width: 'calc(100% - 14px)'
    },
    userName: {
      // paddingTop: '8px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '20px'
    },
    userImageContainer: {
      width: '48px',
      height: '48px'
    },
    cardDetails: {
      padding: '16px'
    }
    // sliderContainer: {
    //   marginRight: '-24px'
    // },
  }
}));

export default useTestimonialStyles;
